module.exports = __webpack_public_path__ + "img/crossRedBalloneHalf.8672939f.png";